import React from 'react';

/**
 * Shared unread-count pill rendered over any bottom-nav icon.
 *
 * - Renders nothing when `count <= 0`.
 * - Clamps huge counts to `99+`.
 * - Breathing animation: 1.8s ease-in-out infinite, subtly scales (1 → 1.08)
 *   and pulses an outer red glow. Matches the cadence of the old green dot
 *   so the visual language stays consistent across guest/host/venue surfaces.
 */
const UnreadBadge = ({ count, dataTestId }) => {
  if (!count || count <= 0) return null;
  const display = count > 99 ? '99+' : String(count);

  return (
    <>
      <style>{`@keyframes allure-unread-breathe {
        0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(229, 57, 53, 0.35); }
        50% { transform: scale(1.08); box-shadow: 0 0 0 6px rgba(229, 57, 53, 0); }
      }`}</style>
      <div
        data-testid={dataTestId}
        style={{
          position: 'absolute',
          top: 2,
          right: 2,
          minWidth: 18,
          height: 18,
          padding: '0 5px',
          borderRadius: 9,
          backgroundColor: '#E53935',
          color: '#FFFFFF',
          fontFamily: "'Inria Serif', serif",
          fontSize: 11,
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px solid #FFFFFF',
          lineHeight: 1,
          pointerEvents: 'none',
          animation: 'allure-unread-breathe 1.8s ease-in-out infinite',
          transformOrigin: 'center center',
        }}
      >
        {display}
      </div>
    </>
  );
};

export default UnreadBadge;
